/* eslint-disable quotes */
import React, { useContext, useState } from 'react';
import Button from 'antd/lib/button';
import Modal from 'antd/lib/modal';
import { ModelContext } from '../metadata/ModelSource';
import { StepsValidationStatusContext } from '../../context/StepsValidationStatusProvider';
import { DeleteOutlined } from "@ant-design/icons";
import { describeVehicle } from './risk/VehicleTypeBtn';

export const RemoveBeanBtn = ({ path, proto, ...props }) => {
  const applicationModel = useContext(ModelContext);
  const { deletingItem, setDeletingItem } = useContext(StepsValidationStatusContext);

  const [showModal, setShowModal] = useState(props.prefix === deletingItem.id);
  const [removeMessage, setRemoveMessage] = useState(props.prefix === deletingItem.id ? deletingItem.message : '');

  let formPrefix = props.prefix;

  let lastBracketIndex = formPrefix.lastIndexOf('[');

  if (lastBracketIndex === -1) {
    //extra check if the button is not in the context of a collection
    return null;
  }

  const containerPath = formPrefix.substring(0, lastBracketIndex);
  const container = applicationModel.getValue(containerPath);
  const currentBean = applicationModel.getValue(
    formPrefix.substring(0, formPrefix.lastIndexOf(']') + 1)
  );

  if (!container || !currentBean) {
    return null;
  }

  const displayModal = () => {
    let deleteMessage;

    const type = props.type.toLowerCase();

    if (currentBean.partyTypeCd) {
      // bean is a driver
      deleteMessage = `Are you sure you want to remove the ${type}?`;
      if (currentBean.nameInfo) {
        const name = currentBean.nameInfo.givenName;
        deleteMessage = `Are you sure you want to remove ${type} ${name}?`;
      }
    }

    if (currentBean.partyInfo) {
      // bean is additional interest
      deleteMessage = `Are you sure you want to remove the additional interest?`;
    }

    if (currentBean.typeCd) {
      // bean is a vehicle
      let displayLabel = describeVehicle(props.type).toLowerCase();
      deleteMessage = `Are you sure you want to remove the ${displayLabel}?`;
      if (
        currentBean.vehicle &&
        currentBean.vehicle.modelYr &&
        currentBean.vehicle.manufacturer
      ) {
        const name = `${currentBean.vehicle.modelYr} ${currentBean.vehicle.manufacturer}`;
        deleteMessage = `Are you sure you want to remove ${displayLabel} ${name}?`;
      }
    }

    setRemoveMessage(deleteMessage);
    setDeletingItem({id: props.prefix, message: deleteMessage});
    setShowModal(true);
  };

  const removeBean = () => {
    // If a bean has already been sent to the api an id will be set. To keep from having issues with future api calls, set the status to deleted.
    // If it has NOT been sent to the api, remove the bean from the application.
    if (currentBean.id) {
      container.forEach((bean, index) => {
        if (bean.id === currentBean.id) {
          bean.status = 'Deleted';
        }
      });
    } else {
      container.splice(
        container.findIndex(item => {
          return item._tempId === currentBean._tempId;
        }),
        1
      );
    }
    applicationModel.modification();
    setDeletingItem({});
    setShowModal(false);
  };

  return (
    <>
      <Modal
        title="Confirmation"
        visible={showModal}
        onCancel={() => setShowModal(false)}
        footer={[
          // <Button
          //   key="back"
          //   onClick={() => setShowModal(false)}
          // >
          //   No
          // </Button>
          <button
            className="cancel-button"
            // style={{ border: 'none', backgroundColor: #ffffff, color: '' }}
            key="back"
            onClick={() => {setShowModal(false); setDeletingItem('');}}
          >
            No
          </button>,
          <Button className="remove-button"key="submit" type="primary" onClick={() => removeBean()}>
            Remove
          </Button>
        ]}
      >
        <p>{removeMessage}</p>
      </Modal>
      <Button onClick={() => displayModal()} {...props} type="link" icon={<DeleteOutlined />} >
      </Button>
    </>
  );
};
